export function stringify(obj : any): string {
  return new JSV().stringify(obj);
}   

class JSV {
  constructor() {}

  stringify(obj: any): string  {
    let result = this.serialize(obj);
    if (result == null) return "";
    return result;
  } 

  serialize(obj: any): string | null {
    if (obj === null || obj === undefined) return null;

    var typeOf = typeof obj;
    if (obj === "function") return null;

    if (typeOf === "object") {
      var ctorStr = obj.constructor.toString().toLowerCase();
      if (ctorStr.indexOf("string") != -1) return this.escapeString(obj);
      if (ctorStr.indexOf("boolean") != -1) return obj ? "True" : "False";
      if (ctorStr.indexOf("number") != -1) return obj;
      if (ctorStr.indexOf("date") != -1)
        return this.escapeString(this.toXsdDateTime(obj));
      if (ctorStr.indexOf("array") != -1) return this.serializeArray(obj);

      return this.serializeObject(obj);
    } else {
      switch (typeOf) {
        case "string":
          return this.escapeString(obj);
          break;
        case "boolean":
          return obj ? "True" : "False";
          break;
        // case "date":
        //   return this.escapeString(this.toXsdDateTime(obj));
        //   break;
        // case "array":
        //   return this.serializeArray(obj);
        //   break;
        case "number":
        default:
          return obj;
      }
    }
  }

  isString_(a: any): boolean {
    if (a === null || a === undefined) return false;
    return typeof a === "string"
      ? true
      : typeof a === "object"
      ? a.constructor.toString().match(/string/i) !== null
      : false;
  }

  escapeString(str: string): string | null {
    if (str === undefined || str === null) return null;
    if (str === "") return '""';

    if (str.indexOf('"')) {
      str = str.replace(/"/g, '""');
    }
    if (this.containsAny_(str, this.ESCAPE_CHARS)) {
      return '"' + str + '"';
    }
    return str;
  }

  containsAny_(str: any, tests: any) {
    if (!this.isString_(str)) return;
    for (var i = 0, len = tests.length; i < len; i++) {
      if (str.indexOf(tests[i]) != -1) return true;
    }
    return false;
  }

  serializeArray(array: any) {
    var value,
      sb = new StringBuffer();
    for (var i = 0, len = array.length; i < len; i++) {
      value = array[i];
      if (this.isEmpty_(value) || this.isFunction_(value)) continue;

      if (sb.getLength() > 0) sb.append(",");

      sb.append(this.stringify(value));
    }
    return "[" + sb.toString() + "]";
  }

  serializeObject(obj : any) {
    var value,
      sb = new StringBuffer();
    for (var key in obj) {
      value = obj[key];
      if (
        !obj.hasOwnProperty(key) ||
        this.isEmpty_(value) ||
        this.isFunction_(value)
      )
        continue;

      if (sb.getLength() > 0) sb.append(",");

      sb.append(this.escapeString(key));
      sb.append(":");
      sb.append(this.stringify(value));
    }
    return "{" + sb.toString() + "}";
  }
  toXsdDateTime(date : any) : string {
    function pad(n: any) : string {
      var s = n.toString();
      return s.length < 2 ? "0" + s : s;
    }
    var yyyy = date.getUTCFullYear();
    var MM = pad(date.getUTCMonth() + 1);
    var dd = pad(date.getUTCDate());
    var hh = pad(date.getUTCHours());
    var mm = pad(date.getUTCMinutes());
    var ss = pad(date.getUTCSeconds());
    var ms = pad(date.getUTCMilliseconds());

    return (
      yyyy +
      "-" +
      MM +
      "-" +
      dd +
      "T" +
      hh +
      ":" +
      mm +
      ":" +
      ss +
      "." +
      ms +
      "Z"
    );
  }

  ESCAPE_CHARS = ['"', ",", "{", "}", "[", "]"];

  isEmpty_(a : any) : boolean {
    return a === null || a === undefined || a === "";
  }
  isFunction_(a:any) : boolean {
    return typeof a === "function"
      ? a.constructor.toString().match(/Function/) !== null
      : false;
  }
}


class StringBuffer
{
    constructor() {
        this.buffer = [];
    }
    append(s : string | null) {
        if (s === null) return;
        this.buffer.push(s);
    }
    toString() : string {
        return this.buffer.join("");
    }
    getLength() : number {
        return this.buffer.length;
    }

    buffer = [] as string[];
}